import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HowItWorksPage = lazy(() => import('../pages/how-it-works/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const BrokerSignUpPage = lazy(() => import('../pages/broker-signup/page'));
const BrokerTrainingPage = lazy(() => import('../pages/broker-training/page'));
const BrokerPartnershipPage = lazy(() => import('../pages/broker-partnership/page'));
const SubmitDealPage = lazy(() => import('../pages/submit-deal/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsAndConditionsPage = lazy(() => import('../pages/terms-and-conditions/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorksPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/broker-signup',
    element: <BrokerSignUpPage />,
  },
  {
    path: '/broker-training',
    element: <BrokerTrainingPage />,
  },
  {
    path: '/broker-partnership',
    element: <BrokerPartnershipPage />,
  },
  {
    path: '/submit-deal',
    element: <SubmitDealPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsAndConditionsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;